/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum BlobType {
  Image,
  Video,
}
